// Product Image Zoom
// - Desktop: inline hover lens + result panel (new), click for full-screen overlay (existing)
// - Mobile: click for full-screen overlay with pinch/pan (existing, unchanged)

document.addEventListener('DOMContentLoaded', function() {
    const mainImage = document.querySelector('.main-product-image');
    if (!mainImage) return;

    // ─────────────────────────────────────────────
    // INLINE HOVER ZOOM (desktop only)
    // ─────────────────────────────────────────────
    const wrapper   = document.getElementById('main-image-zoom-wrapper');
    const lens      = document.getElementById('zoom-lens');
    const result    = document.getElementById('zoom-result');

    if (wrapper && lens && result) {
        const ZOOM_LEVEL = 2.5; // magnification factor

        function isMobileDevice() {
            return window.innerWidth <= 768 || ('ontouchstart' in window);
        }

        function initInlineZoom() {
            // Use data-zoom-src (1600px) if present, else fall back to current src
            const zoomSrc = mainImage.getAttribute('data-zoom-src') || mainImage.src;

            // Size the result panel to match its CSS dimensions
            const resultW = result.offsetWidth  || 380;
            const resultH = result.offsetHeight || 380;

            result.style.backgroundImage  = 'url("' + zoomSrc + '")';
            result.style.backgroundSize   = (mainImage.offsetWidth  * ZOOM_LEVEL) + 'px ' +
                                            (mainImage.offsetHeight * ZOOM_LEVEL) + 'px';

            // Lens size relative to result panel size
            lens.style.width  = Math.round(resultW / ZOOM_LEVEL) + 'px';
            lens.style.height = Math.round(resultH / ZOOM_LEVEL) + 'px';
        }

        function moveLens(e) {
            if (isMobileDevice()) return;

            e.preventDefault();

            const rect    = mainImage.getBoundingClientRect();
            const lensW   = lens.offsetWidth;
            const lensH   = lens.offsetHeight;
            const resultW = result.offsetWidth  || 380;
            const resultH = result.offsetHeight || 380;

            // Cursor position relative to image
            let x = (e.clientX || e.touches[0].clientX) - rect.left;
            let y = (e.clientY || e.touches[0].clientY) - rect.top;

            // Clamp lens within image bounds
            x = Math.max(lensW / 2, Math.min(rect.width  - lensW / 2, x));
            y = Math.max(lensH / 2, Math.min(rect.height - lensH / 2, y));

            // Position lens centred on cursor
            lens.style.left = (x - lensW / 2) + 'px';
            lens.style.top  = (y - lensH / 2) + 'px';

            // Calculate background position for result panel
            const bgX = ((x - lensW / 2) / rect.width)  * (mainImage.offsetWidth  * ZOOM_LEVEL - resultW);
            const bgY = ((y - lensH / 2) / rect.height)  * (mainImage.offsetHeight * ZOOM_LEVEL - resultH);

            result.style.backgroundPosition = '-' + bgX + 'px -' + bgY + 'px';
        }

        function showZoom() {
            if (isMobileDevice()) return;
            initInlineZoom();
            lens.style.display   = 'block';
            result.style.display = 'block';
        }

        function hideZoom() {
            lens.style.display   = 'none';
            result.style.display = 'none';
        }

        wrapper.addEventListener('mouseenter', showZoom);
        wrapper.addEventListener('mouseleave', hideZoom);
        wrapper.addEventListener('mousemove',  moveLens);

        // Re-initialise when the main image src changes (thumbnail click / variant change)
        const srcObserver = new MutationObserver(function() {
            if (result.style.display === 'block') {
                initInlineZoom();
            }
        });
        srcObserver.observe(mainImage, { attributes: true, attributeFilter: ['src', 'data-zoom-src'] });

        // Re-initialise on window resize
        window.addEventListener('resize', function() {
            if (!isMobileDevice()) hideZoom(); // just reset; will re-init on next hover
        });
    }


    // ─────────────────────────────────────────────
    // FULL-SCREEN OVERLAY (mobile + desktop click)
    // ─────────────────────────────────────────────
    function isMobile() {
        return window.innerWidth <= 768 || ('ontouchstart' in window);
    }

    let zoomOverlay = null;
    let overlayImage = null;
    let currentZoom = 1;
    let currentPanX = 0;
    let currentPanY = 0;
    let initialDistance = 0;
    let isPinching = false;
    let isPanning = false;
    let lastPanX = 0;
    let lastPanY = 0;
    let startPanX = 0;
    let startPanY = 0;
    let initialZoomOnPinch = 1;

    function createOverlay() {
        if (zoomOverlay) return;

        zoomOverlay = document.createElement('div');
        zoomOverlay.className = 'product-zoom-overlay';
        zoomOverlay.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.95);
            z-index: 9999;
            display: none;
            justify-content: center;
            align-items: center;
            touch-action: none;
        `;

        const closeBtn = document.createElement('button');
        closeBtn.className = 'zoom-close-btn';
        closeBtn.innerHTML = '✕';
        closeBtn.style.cssText = `
            position: absolute;
            top: 20px;
            right: 20px;
            background: rgba(255, 255, 255, 0.9);
            border: none;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            font-size: 24px;
            cursor: pointer;
            z-index: 10000;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #000;
        `;
        closeBtn.addEventListener('click', closeOverlay);

        const helpText = document.createElement('div');
        helpText.className = 'zoom-help-text';
        helpText.innerHTML = 'Use mouse wheel to zoom • Drag to pan';
        helpText.style.cssText = `
            position: absolute;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
            background: rgba(0, 0, 0, 0.7);
            color: white;
            padding: 8px 16px;
            border-radius: 20px;
            font-size: 14px;
            z-index: 10000;
            pointer-events: none;
            display: none;
        `;
        if (!isMobile()) helpText.style.display = 'block';

        const imageContainer = document.createElement('div');
        imageContainer.style.cssText = `
            width: 100%;
            height: 100%;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
        `;

        overlayImage = document.createElement('img');
        overlayImage.style.cssText = `
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            transform-origin: center center;
            transition: transform 0.1s ease-out;
            user-select: none;
            -webkit-user-select: none;
        `;

        imageContainer.appendChild(overlayImage);
        zoomOverlay.appendChild(closeBtn);
        zoomOverlay.appendChild(helpText);
        zoomOverlay.appendChild(imageContainer);
        document.body.appendChild(zoomOverlay);

        overlayImage.addEventListener('touchstart', handleTouchStart, { passive: false });
        overlayImage.addEventListener('touchmove',  handleTouchMove,  { passive: false });
        overlayImage.addEventListener('touchend',   handleTouchEnd,   { passive: false });
        overlayImage.addEventListener('mousedown',  handleMouseDown);
        overlayImage.addEventListener('mousemove',  handleMouseMove);
        overlayImage.addEventListener('mouseup',    handleMouseUp);
        overlayImage.addEventListener('mouseleave', handleMouseUp);
        overlayImage.addEventListener('wheel',      handleWheel, { passive: false });

        zoomOverlay.addEventListener('click', function(e) {
            if (e.target === zoomOverlay) closeOverlay();
        });
    }

    function openOverlay() {
        createOverlay();
        overlayImage.src = mainImage.src;
        currentZoom = 1;
        currentPanX = 0;
        currentPanY = 0;
        applyTransform();
        zoomOverlay.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        updateCursor();
    }

    function closeOverlay() {
        if (zoomOverlay) {
            zoomOverlay.style.display = 'none';
            document.body.style.overflow = '';
            currentZoom = 1;
            currentPanX = 0;
            currentPanY = 0;
            applyTransform();
        }
    }

    function applyTransform() {
        if (!overlayImage) return;
        overlayImage.style.transform  = `translate(${currentPanX}px, ${currentPanY}px) scale(${currentZoom})`;
        overlayImage.style.transition = isPinching || isPanning ? 'none' : 'transform 0.1s ease-out';
    }

    function applyZoom(zoomLevel, centerX, centerY) {
        const oldZoom = currentZoom;
        currentZoom = Math.max(1, Math.min(5, zoomLevel));

        if (centerX !== undefined && centerY !== undefined && overlayImage) {
            const rect        = overlayImage.getBoundingClientRect();
            const imageCenter = { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
            const offsetX     = centerX - imageCenter.x;
            const offsetY     = centerY - imageCenter.y;
            const zoomRatio   = currentZoom / oldZoom;
            currentPanX = currentPanX * zoomRatio + offsetX * (1 - zoomRatio);
            currentPanY = currentPanY * zoomRatio + offsetY * (1 - zoomRatio);
        }

        if (currentZoom <= 1) {
            currentPanX = 0;
            currentPanY = 0;
        } else {
            constrainPan();
        }
        applyTransform();
    }

    function constrainPan() {
        if (currentZoom <= 1 || !overlayImage) {
            currentPanX = 0;
            currentPanY = 0;
            return;
        }
        const container  = overlayImage.parentElement.getBoundingClientRect();
        const imageRect  = overlayImage.getBoundingClientRect();
        const scaledWidth  = imageRect.width  * currentZoom / (overlayImage.style.transform.includes('scale') ? 1 : currentZoom);
        const scaledHeight = imageRect.height * currentZoom / (overlayImage.style.transform.includes('scale') ? 1 : currentZoom);
        const maxPanX = Math.max(0, (scaledWidth  - container.width)  / 2);
        const maxPanY = Math.max(0, (scaledHeight - container.height) / 2);
        currentPanX = Math.max(-maxPanX, Math.min(maxPanX, currentPanX));
        currentPanY = Math.max(-maxPanY, Math.min(maxPanY, currentPanY));
    }

    function applyPan(panX, panY) {
        if (currentZoom <= 1) return;
        currentPanX = panX;
        currentPanY = panY;
        constrainPan();
        applyTransform();
    }

    function getDistance(t1, t2) {
        return Math.sqrt(Math.pow(t1.clientX - t2.clientX, 2) + Math.pow(t1.clientY - t2.clientY, 2));
    }

    function getTouchCenter(t1, t2) {
        return { x: (t1.clientX + t2.clientX) / 2, y: (t1.clientY + t2.clientY) / 2 };
    }

    function handleTouchStart(e) {
        if (e.touches.length === 2) {
            initialDistance    = getDistance(e.touches[0], e.touches[1]);
            initialZoomOnPinch = currentZoom;
            isPinching = true;
            isPanning  = false;
            e.preventDefault();
        } else if (e.touches.length === 1 && currentZoom > 1) {
            isPanning  = true;
            isPinching = false;
            startPanX  = e.touches[0].clientX;
            startPanY  = e.touches[0].clientY;
            lastPanX   = currentPanX;
            lastPanY   = currentPanY;
            e.preventDefault();
        }
    }

    function handleTouchMove(e) {
        if (e.touches.length === 2 && isPinching) {
            e.preventDefault();
            const scale  = getDistance(e.touches[0], e.touches[1]) / initialDistance;
            const center = getTouchCenter(e.touches[0], e.touches[1]);
            applyZoom(initialZoomOnPinch * scale, center.x, center.y);
        } else if (e.touches.length === 1 && isPanning && currentZoom > 1) {
            e.preventDefault();
            applyPan(lastPanX + e.touches[0].clientX - startPanX,
                     lastPanY + e.touches[0].clientY - startPanY);
        }
    }

    function handleTouchEnd(e) {
        if (e.touches.length === 0) {
            initialDistance = 0;
            isPinching = false;
            isPanning  = false;
        } else if (e.touches.length === 1 && isPinching) {
            isPinching = false;
            isPanning  = true;
            startPanX  = e.touches[0].clientX;
            startPanY  = e.touches[0].clientY;
            lastPanX   = currentPanX;
            lastPanY   = currentPanY;
        }
    }

    function handleMouseDown(e) {
        if (currentZoom > 1) {
            isPanning  = true;
            startPanX  = e.clientX;
            startPanY  = e.clientY;
            lastPanX   = currentPanX;
            lastPanY   = currentPanY;
            overlayImage.style.cursor = 'grabbing';
            e.preventDefault();
        }
    }

    function handleMouseMove(e) {
        if (isPanning && currentZoom > 1) {
            e.preventDefault();
            applyPan(lastPanX + e.clientX - startPanX,
                     lastPanY + e.clientY - startPanY);
        }
    }

    function handleMouseUp() {
        if (isPanning) {
            isPanning = false;
            updateCursor();
        }
    }

    function handleWheel(e) {
        e.preventDefault();
        const delta  = e.deltaY > 0 ? -0.2 : 0.2;
        applyZoom(currentZoom + delta, e.clientX, e.clientY);
        updateCursor();
    }

    function updateCursor() {
        if (!overlayImage) return;
        overlayImage.style.cursor = currentZoom > 1 ? 'grab' : 'zoom-in';
    }

    // Click opens full-screen overlay on both mobile and desktop
    wrapper ? wrapper.addEventListener('click', function(e) {
        // Only open overlay on mobile (desktop gets hover zoom; click still works as bonus)
        openOverlay();
    }) : mainImage.addEventListener('click', function(e) {
        e.preventDefault();
        openOverlay();
    });

    mainImage.style.cursor = 'pointer';

    // Sync overlay image when main image src changes
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'src') {
                if (overlayImage && zoomOverlay && zoomOverlay.style.display === 'flex') {
                    overlayImage.src = mainImage.src;
                    currentZoom = 1;
                    currentPanX = 0;
                    currentPanY = 0;
                    applyTransform();
                }
            }
        });
    });
    observer.observe(mainImage, { attributes: true });
});